import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { programmesApi } from '../../api/programmes';
import { projectsApi } from '../../api/projects';
import { StatusBadge } from '../../components/StatusBadge';
import { DataTable } from '../../components/DataTable';

export function ProgrammeDetailPage() {
  const { programmeId } = useParams<{ programmeId: string }>();
  const id = Number(programmeId);

  const programmeQuery = useQuery({ queryKey: ['programme', id], queryFn: () => programmesApi.get(id) });
  const projectsQuery = useQuery({ queryKey: ['projects'], queryFn: () => projectsApi.list() });

  const linkedProjects = projectsQuery.data?.data.filter((p) => p.programme_id === id) ?? [];

  return (
    <div className="page">
      <Link to="/programmes">&larr; Back to Programmes</Link>

      {programmeQuery.data && (
        <>
          <div className="page-header">
            <h1>{programmeQuery.data.data.name}</h1>
          </div>
          <p className="muted">{programmeQuery.data.data.programme_reference} · {programmeQuery.data.data.status}</p>

          <section className="card">
            <h2>Budget rollup</h2>
            <div className="stat">
              <div className="stat-value">{Number(programmeQuery.data.data.budget_rollup ?? 0).toLocaleString()}</div>
              <div className="stat-label">Total across all linked projects</div>
            </div>
          </section>

          <section className="card">
            <h2>Projects under this programme</h2>
            <DataTable
              rows={linkedProjects}
              rowKey={(p) => p.id}
              emptyMessage="No projects linked to this programme yet."
              columns={[
                { header: 'Reference', render: (p) => <Link to={`/projects/${p.id}`}>{p.project_reference}</Link> },
                { header: 'Name', render: (p) => p.project_name },
                { header: 'Status', render: (p) => <StatusBadge status={p.status} /> },
                { header: 'Budget', render: (p) => `${p.currency_code} ${Number(p.budget_total).toLocaleString()}` },
              ]}
            />
          </section>
        </>
      )}
    </div>
  );
}
